// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as MarkdownTableExtended } from '../../../assets/icons/extended/markdown/markdown-table.svg?react';
import { createIcons } from '../../Icon';
const MarkdownTableIcon = /* @__PURE__ */ createIcons('MarkdownTable', {
    extended: MarkdownTableExtended
});
MarkdownTableIcon.supportedTypes = ['extended'];
MarkdownTableIcon.category = 'markdown';
export default MarkdownTableIcon;
